import femaleAyahModernImage from 'assets/images/ab_test_313_gender_female.webp'
import maleAyahModernImage from 'assets/images/ab_test_313_gender_male.webp'
import femaleAyahImage from 'assets/images/gender-female-ayah.png'
import femaleKarmaImage from 'assets/images/gender-female-karmapath.png'
import maleAyahImage from 'assets/images/gender-male-ayah.png'
import maleKarmaImage from 'assets/images/gender-male-karmapath.png'
import maleAyahWTypeWomanImage from 'assets/images/muslim_man_wtype_image.webp'
import femaleAyahWTypeWomanImage from 'assets/images/muslim_woman_wtype_image.webp'

import { Cohort, Gender, PageVersions } from 'root-constants'
import { TPageVersion, TPartialMap, TPartialMapWithDefault } from 'root-types'

import { TGenderOption } from '../types'

const CLASSIC_GENDER_OPTIONS_FEMALE_FIRST = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleAyahImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleAyahImage,
  },
] as const satisfies readonly TGenderOption[]

const CLASSIC_GENDER_OPTIONS_MALE_FIRST = [
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleAyahImage,
  },
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleAyahImage,
  },
] as const satisfies readonly TGenderOption[]

const KARMA_GENDER_OPTIONS = [
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleKarmaImage,
  },
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleKarmaImage,
  },
] as const satisfies readonly TGenderOption[]

const MODERN_AYAH_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleAyahModernImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleAyahModernImage,
  },
] as const satisfies readonly TGenderOption[]

const MODERN_AYAH_GENDER_OPTIONS_MALE_FIRST = [
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.male',
    imageUrl: maleAyahModernImage,
  },
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.female',
    imageUrl: femaleAyahModernImage,
  },
] as const satisfies readonly TGenderOption[]

const GENDER_OPTIONS_V_TYPE = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.sister',
    imageUrl: femaleAyahWTypeWomanImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.brother',
    imageUrl: maleAyahWTypeWomanImage,
  },
] as const satisfies readonly TGenderOption[]

const GENDER_OPTIONS_V_TYPE_WITH_MODERN_IMAGES = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.sister',
    imageUrl: femaleAyahModernImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.brother',
    imageUrl: maleAyahModernImage,
  },
] as const satisfies readonly TGenderOption[]

export const GENDER_OPTIONS_BY_VERSION = {
  [PageVersions.V1]: MODERN_AYAH_GENDER_OPTIONS,
  [PageVersions.V2]: CLASSIC_GENDER_OPTIONS_MALE_FIRST,
  [PageVersions.V3]: CLASSIC_GENDER_OPTIONS_MALE_FIRST,
  [PageVersions.V4]: KARMA_GENDER_OPTIONS,
  [PageVersions.V5]: CLASSIC_GENDER_OPTIONS_FEMALE_FIRST,
  [PageVersions.V6]: MODERN_AYAH_GENDER_OPTIONS_MALE_FIRST,
  [PageVersions.V7]: GENDER_OPTIONS_V_TYPE,
  [PageVersions.V8]: GENDER_OPTIONS_V_TYPE_WITH_MODERN_IMAGES,
  [PageVersions.V9]: MODERN_AYAH_GENDER_OPTIONS,
} as const satisfies TPartialMap<TPageVersion, readonly TGenderOption[]>

export const COHORT_TO_VERSION_MAP = {
  [Cohort.AP_PA_440]: PageVersions.V2,
  [Cohort.AP_PA_440_AM]: PageVersions.V2,
  [Cohort.AP_PA_440_C]: PageVersions.V2,
  [Cohort.AP_PA_440_C_AM]: PageVersions.V2,
  [Cohort.AP_QURAN_315]: PageVersions.V3,
  [Cohort.KP_BS_13]: PageVersions.V4,
  [Cohort.KP_BS_13_C]: PageVersions.V4,
  [Cohort.KP_BS_13_H]: PageVersions.V4,
  [Cohort.KP_BS_13_CC]: PageVersions.V4,
  [Cohort.KP_BS_13_CT]: PageVersions.V4,
  [Cohort.FLOW_AYAH_313]: PageVersions.V1,
  [Cohort.FLOW_AYAH_313_AM]: PageVersions.V1,
  [Cohort.AP_QURAN_313_C]: PageVersions.V1,
  [Cohort.AP_QURAN_313_CF]: PageVersions.V1,
  [Cohort.AP_QURAN_313_C_AM]: PageVersions.V1,
  [Cohort.AP_QURAN_313_CC]: PageVersions.V1,
  [Cohort.AP_QURAN_313_CT]: PageVersions.V1,
  [Cohort.AP_QURAN_410]: PageVersions.V1,
  [Cohort.AP_QURAN_610]: PageVersions.V6,
  [Cohort.AP_PRINTABLE_520]: PageVersions.V5,
  [Cohort.AP_QURAN_326]: PageVersions.V5,
  [Cohort.AP_QURAN_337]: PageVersions.V1,
  [Cohort.AP_SD_313_C]: PageVersions.V8,
  [Cohort.AP_SD_313_CC]: PageVersions.V7,
  [Cohort.AP_QURAN_313_C_V2]: PageVersions.V1,
  [Cohort.AP_WLDB_QUIZ_313]: PageVersions.V9,
  default: PageVersions.V1,
} as const satisfies TPartialMapWithDefault<Cohort, TPageVersion>

export const PAGE_VERSIONS_WITH_SMALL_TEXT = [
  PageVersions.V2,
  PageVersions.V6,
  PageVersions.V9,
]

export const PAGE_VERSIONS_WITH_REGULAR_SUBTITLE = [
  PageVersions.V7,
  PageVersions.V8,
]

export const PRINTABLE_COHORTS = [
  Cohort.AP_FINANCE_313_C,
  Cohort.AP_PRINTABLE_520,
  Cohort.AP_FINANCE_313,
  Cohort.AP_FINANCE_313_AM,
  Cohort.AP_FINANCE_313_C_AM,
]

export const VARIATION_COHORTS = [
  Cohort.AP_FINANCE_313,
  Cohort.AP_FINANCE_313_C,
  Cohort.AP_FINANCE_313_AM,
  Cohort.AP_FINANCE_313_C_AM,
]

export const COMPACT_LABEL_COHORTS = [Cohort.AP_SD_313_C, Cohort.AP_SD_313_CC]
